
export function preLoadWallpapers() {
    const wallpaperList = [
        require('@/assets/wallpaper/wallpaper_main.png'),
    ];
    loadImage(wallpaperList);
}

export function loadImage(imagesList) {
    for(let i = 0; i < imagesList.length; i++) {
        const img = new Image()
        img.src = imagesList[i]
    }
}